export default __webpack_public_path__ + "static/media/HTMLCircularBackground-light-sepia-350px.2c70d442.jpg";